import React from 'react';

const SvgChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.384 29.768"
      {...props}
    >
      <path
        d="M14.263 2.122L1.5 14.884l12.762 12.762"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgChevronLeft;
